import audios from 'a/assets/audio';
import AquaAudio from './AquaAudio';
import TaskSequence from './TaskSequence';
import { noop } from './utilityFunctions';
/**
 * Play audio
 *
 * @param audioTrack {string} - base64 audio track
 * /
 * @param audioTrack {{track: string, name: string}} - base64 audio track, name
 * @param onStart {Function} - onStart cb
 * @param onEnd {Function} - onEnd cb
 */
export const playAudio = (audioTrack, onStart = noop, onEnd = noop) => {
  const autoplay = true;
  const audio = createAudio(
    audioTrack,
    onStart,
    () => {
      audio.sound.unload();
      onEnd();
    },
    autoplay);
  return audio;
};

export const createAudio = (audioTrack, onStart = noop, onEnd = noop, autoplay = false) => {
  const track = typeof audioTrack === 'string' ? audioTrack : audioTrack.track;
  const name = typeof audioTrack === 'string' ? 'audioTrack' : audioTrack.name;
  return new AquaAudio(track, name, {
    autoplay,
    onplay: onStart,
    onend: onEnd,
  });
};

/**
 * Run audio sequence
 *
 * @param audioTracks {Array} - list of tracks
 * @param options
 * @param options:onStart {Function} - onStart cb
 * @param options:onEnd {Function} - onEnd cb
 * @param options:delayBefore {Number} - delay before first audio
 * @param options:delay {Number} - delay between audio tracks
 * @param options:delayAfter {Number} - delay after last audio
 */
export const playAudioSequence = (audioTracks, {
  onStart = noop,
  onEnd = noop,
  delay = 0,
  delayBefore = 0,
  delayAfter = 0,
} = {}) => {
  const audioSequence = new TaskSequence();

  if (delayBefore) audioSequence.addTimeout(delayBefore);
  audioSequence.addConsecutiveTask({
    type: 'action',
    start: onStart,
  });
  if (Array.isArray(audioTracks)) {
    audioTracks.forEach((audioTrack, i) => {
      const trackDelay = i === 0 ? 0 : delay; // don't add delay for first track
      audioSequence.addConsecutiveTask({
        type: 'audiotrack',
        audioTrack,
        audioDesc: 'Audiotrack',
        delay: trackDelay,
      });
    });
  } else {
    console.warn('The sequence must be an array');
  }
  if (delayAfter) audioSequence.addTimeout(delayAfter);
  audioSequence.addConsecutiveTask({
    type: 'action',
    start: onEnd,
  });
  audioSequence.startBatch();

  return audioSequence;
};

export const wrappedPlayAudio = (Loader, audioMapEntry, audioOptions = {}, playAudioHook) => {
  const asset = Loader.getLoadedAsset(audioMapEntry);
  const options = { ...audioOptions };

  if (!options.caption) {
    options.caption = Loader.getCaption(audioMapEntry);
  }

  return {
    play() {
      this.howl = playAudioHook(asset, options);
    },
    unload() {
      if (this.howl) this.howl.unload();
    },
  };
};

export const createAudioWithCaption = (Loader, audioMapEntry, audioOptions = {}) => {
  const asset = Loader.getLoadedAsset(audioMapEntry);
  const options = { ...audioOptions };

  if (!options.caption) {
    options.caption = Loader.getCaption(audioMapEntry);
  }

  return new AquaAudio(asset, audioMapEntry.file || audioMapEntry.name, options);
};

export const playTap = (isHardTap = true, { onStart, onEnd } = {}) => {
  if (isHardTap) {
    playAudio(audios.click, onStart, onEnd);
  } else {
    playAudio(audios.tap, onStart, onEnd);
  }
};

export const playPop = () => {
  playAudio(audios.pop);
};

export const playSlide = () => {
  playAudio(audios.slide);
};

export const playLevelMasteryK3 = () => {
  playAudio(audios.levelMasteryK3);
};

export const playLevelMastery45 = () => {
  playAudio(audios.levelMastery45);
};

export { AquaAudio, TaskSequence };
